import { cn } from '../../lib/utils';
import { Check, Clock, AlertTriangle, XCircle, Info, RefreshCw } from 'lucide-react';

const statusConfig = {
  success: {
    className: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    icon: Check,
  },
  warning: {
    className: 'bg-amber-50 text-amber-700 border-amber-200',
    icon: Clock,
  },
  danger: {
    className: 'bg-red-50 text-red-700 border-red-200',
    icon: XCircle,
  },
  info: {
    className: 'bg-blue-50 text-blue-700 border-blue-200',
    icon: Info,
  },
  neutral: {
    className: 'bg-slate-50 text-slate-600 border-slate-200',
    icon: Clock,
  },
  pending: {
    className: 'bg-amber-50 text-amber-700 border-amber-200',
    icon: RefreshCw,
  },
};

export const StatusBadge = ({ status, label, showIcon = true, size = 'default', className }) => {
  const config = statusConfig[status] || statusConfig.neutral;
  const Icon = config.icon;

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border font-medium',
        size === 'sm' ? 'text-[10px]' : 'text-xs',
        config.className,
        className
      )}
      data-testid={`status-badge-${status}`}
    >
      {showIcon && <Icon className={cn('flex-shrink-0', size === 'sm' ? 'w-3 h-3' : 'w-3.5 h-3.5')} />}
      {label}
    </span>
  );
};

export default StatusBadge;
